import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=d6a6cf54&scoped=true"
import script from "./tableData.vue?vue&type=script&lang=js"
export * from "./tableData.vue?vue&type=script&lang=js"
import style0 from "./tableData.vue?vue&type=style&index=0&id=d6a6cf54&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a6cf54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6a6cf54')) {
      api.createRecord('d6a6cf54', component.options)
    } else {
      api.reload('d6a6cf54', component.options)
    }
    module.hot.accept("./tableData.vue?vue&type=template&id=d6a6cf54&scoped=true", function () {
      api.rerender('d6a6cf54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reverse/upload/components/tableData.vue"
export default component.exports